<div class="w-full rounded-lg border border-border overflow-x-auto">
  <div class="p-6 min-w-max">
    @for (section of visibleSections(); track section.title) {
      <div class="bg-table-header/40 px-4 py-3 rounded-lg">
        <div class="grid items-center gap-4" [style.gridTemplateColumns]="gridTemplateColumns()">
          <div class="font-semibold text-text-primary">
            {{ section.title }}
          </div>

          @for (solution of solutions(); track solution.id) {
            <div
              class="flex items-center justify-end gap-2 font-semibold"
              [ngClass]="{ 'text-green': solution.isGreener, 'text-text-primary': !solution.isGreener }">
              <span>{{ solution.name }}</span>
              @if (solution.isGreener) {
                <lucide-icon class="w-4 h-4 text-green" [name]="badge" />
              }
            </div>
          }
        </div>
      </div>

      @for (row of section.rows; track row.key) {
        <div class="px-4 py-3 rounded-lg hover:bg-table-header/20 transition-colors">
          <div class="grid items-center gap-4" [style.gridTemplateColumns]="gridTemplateColumns()">
            <div class="text-text-primary">
              {{ row.label }}
              @if (row.rowUnit) {
                <span class="text-text-secondary">({{ row.rowUnit }})</span>
              }
            </div>

            @for (solution of solutions(); track solution.id) {
              @let d = displayCell(row.getValue(solution));
              <div class="flex justify-end text-text-primary">
                <span>{{ d.text }}</span>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
